import * as CriteriaManagementGroupConstants from '../actions/CriteriaManagementGroup/CriteriaManagementGroupConstants';
import { CriteriaManagementGroupState } from '../actions/CriteriaManagementGroup/CriteriaManagementGroupTypes';

export default (state = CriteriaManagementGroupConstants.DEFAULT_STATE, action: any): CriteriaManagementGroupState => {
  switch (action.type) {
    case CriteriaManagementGroupConstants.CriteriaManagementGroupActionTypes.LOADED_CRITERIAMANAGEMENTGROUP_CRITERIA:
      return { ...state, criteria: action.payload.data.Criteria };
    case CriteriaManagementGroupConstants.CriteriaManagementGroupActionTypes.LOADED_CRITERIAMANAGEMENTGROUP_CRITERIA_WITHMAPPING:
      return { ...state, criteriaWithMapping: action.payload.data.CriteriaManagementGroup.CriteriaWithMapping };
    case CriteriaManagementGroupConstants.CriteriaManagementGroupActionTypes.LOADED_OFFER_CONFIG:
      return { ...state, offerConfigSignupTableColumn: action.payload.data.OfferConfigGroup.SignupTableColumn };
    default:
      return state;
  }
};
